module.exports = __webpack_public_path__ + "9863e1edf0591c802a3f82d04d2b3ca1.MP3";